import { defineStore } from "pinia";
import { computed, reactive, toRefs } from "vue";
import { RouterList, constantRouterMap } from "@/router/index.js";
import { getToken, removeToken } from "../../utils/auth";
import router from "@/router/index.js";
import { UserInfoStore } from "@/stores";
import { GetUserMenuList } from "@/api/menu.js";
const modules = import.meta.glob("@/views/**/**.vue");
// console.log(modules)
export const GenerateRoutesStore = defineStore("Routes", () => {
  const userStore = UserInfoStore();
  const state = reactive({
    addRouters: [], //菜单路由
    routers: [], // 项目路由
  });
  // 合并路由
  const GenerateRoutes = (perm) => {
    return new Promise(async (resolve, reject) => {
      const result = await GetUserMenuList();
      userStore.SETMENULIST(result.data.data);
      state.addRouters = [
        ...RouterList,
        ...translateComponent(userStore.menuList),
      ];
      state.routers = [...state.addRouters];
      console.log(state.routers)
      resolve(state.routers);
    });
  };
  const translateComponent = (data) => {
    let arr = [];
    data.forEach((v, i) => {
		const component = modules[`/src/views/${v.component}.vue`]
      const obj = {
        path: v.path,
        name: v.name.replace(/\//g,''),
        hidden: v.hidden, //是否隐藏
        redirect:
          v.redirect == "noRedirect"
            ? v.redirect
            : v.children && v.children.length > 0
            ? `${v.children[0].path}`
            : "",
        //替代 ()=>import  vite不支持
        component:
          v.component == "Layout"
            ? modules["/src/views/Layout/Layout.vue"]
            : component?component:modules["/src/views/404.vue"],
        meta: {
          title: v.meta.title,
          icon: v.meta.icon, //v.icon
          tabHidden: v.tabHidden, //是否隐藏标签页
          levelHidden: v.levelHidden, //是否隐藏当前菜单目录
          isCache: v.meta.noCache, //是否缓存当前菜单 默认不缓存
          isLink: v.meta.link,
        },
        children:
          v.children && v.children.length > 0
            ? translateComponent(v.children)
            : [],
      };
      arr.push(obj);
    });
    return arr;
  };
  const permission_routers = computed(() => {
    return state.addRouters;
  });
  return {
    GenerateRoutes,
    permission_routers,
    ...toRefs(state),
  };
});
